import React, { Component } from "react";
import PropTypes from "prop-types";

import PriceBlock from "../PriceBlock";
import ColorsBlock from "../ColorsBlock";
import SizeBlock from "../SizeBlock";
import PromotionBlock from "../PromotionBlock";
import { Button, Ripple, Utils } from "arv-reactcomponents";
import { isDesktop, sanitiseUrl } from "../../../utils";

class ProductRightPanel extends Component {
  static target() {
    return isDesktop ? "_blank" : "";
  }
  get isNewClassName() {
    const { isNew } = this.props.pdpDetails;
    return isNew ? "" : "nwc-hide";
  }
  get isInStock() {
    const { inStock } = this.props.pdpDetails;
    return inStock ? "" : "nwc-hide";
  }

  get isOutOfStock() {
    const { ProductLoader, pdpDetails: { inStock } } = this.props;
    if (ProductLoader) {
      return <p className="nw-product-stock nwc-contentloader" />;
    }
    return inStock ? (
      ""
    ) : (
      <span className="nw-product-stock">OUT OF STOCK</span>
    );
  }
  get brandClickableUrl() {
    return this.props.pdpDetails.brandClickableUrl
      ? sanitiseUrl(this.props.pdpDetails.brandClickableUrl)
      : "";
  }

  render() {
    const {
      className,
      buttonText,
      ProductLoader,
      selectedSku,
      skuId,
    } = this.props;
    const {
      skus,
      colors,
      discountRange,
      mrpRange,
      sellingPriceRange,
      promotions,
      inStock,
      styleId,
      brandName,
      name,
    } = this.props.pdpDetails;
    return (
      <div
        className={`nw-pdp-right-panel ${className}`}
        itemScope
        itemType="http://schema.org/Product"
      >
        <div className="nw-product-name">
          <div
            className={`
              nw-product-isnewtxt
              ${this.isNewClassName}
            `}
          >
            NEW IN
          </div>
          <a
            className="nw-product-brandtxt-anchor"
            href={this.brandClickableUrl}
            target={ProductRightPanel.target()}
          >
            <h3 className="nw-product-brandtxt" itemProp="brand">
              {brandName}
            </h3>
          </a>
          <div className="nw-product-titletxt">
            <p className="nw-product-title" itemProp="name">
              {name}
            </p>
          </div>
          {this.isOutOfStock}
        </div>
        <PriceBlock
          discountRange={discountRange}
          mrpRange={mrpRange}
          sellingPriceRange={sellingPriceRange}
          selectedSku={selectedSku}
          ProductLoader={ProductLoader}
          showTC
          promotions={promotions}
          className={`nw-product-price ${this.isInStock}`}
        />
        <PromotionBlock promotions={promotions} ProductLoader={ProductLoader} />
        <SizeBlock
          selectedSkuId={skuId}
          selectSku={this.props.selectSku}
          skus={skus}
          ProductLoader={ProductLoader}
        />
        <ColorsBlock
          styleId={styleId}
          setStyle={this.props.setStyle}
          setMainImage={this.props.setMainImage}
          ProductLoader={ProductLoader}
          colors={colors}
        />
        <div className="nw-pdp-button">
          <Ripple className="nwc-ripple-light">
            <Button
              className="nwc-btn-primary nw-pdp-addtobag"
              disabled={!inStock}
              onClick={this.props.addToBag}
            >
              {buttonText}
            </Button>
          </Ripple>
        </div>
      </div>
    );
  }
}
ProductRightPanel.defaultProps = {
  setStyle: Utils.noop,
  buttonText: "ADD TO BAG",
  selectedSku: {},
  ProductLoader: false,
  skuId: "",
  pdpDetails: {
    brandClickableUrl: "",
    skus: [],
    colors: [],
    inStock: false,
    discountRange: {
      min: 0,
      max: 0,
    },
    mrpRange: {
      min: 0,
      max: 0,
    },
    sellingPriceRange: {
      min: 0,
      max: 0,
    },
    isNew: false,
    promotions: [],
    brandName: "",
    name: "",
    styleId: "",
  },
};

ProductRightPanel.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string.isRequired,
  setMainImage: PropTypes.func.isRequired,
  selectSku: PropTypes.func.isRequired,
  setStyle: PropTypes.func,
  addToBag: PropTypes.func.isRequired,
  selectedSku: PropTypes.shape({}),
  ProductLoader: PropTypes.bool,
  skuId: PropTypes.string,
  pdpDetails: PropTypes.shape({
    brandClickableUrl: PropTypes.string,
    skus: PropTypes.arrayOf(PropTypes.shape({})),
    colors: PropTypes.shape([]),
    inStock: PropTypes.bool,
    discountRange: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
    mrpRange: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
    sellingPriceRange: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
    isNew: PropTypes.bool,
    promotions: PropTypes.arrayOf(PropTypes.object),
    brandName: PropTypes.string,
    name: PropTypes.string,
    styleId: PropTypes.string,
  }),
};

export default ProductRightPanel;



// WEBPACK FOOTER //
// ./src/component/ProductList/ProductRightPanel/index.js